module.exports = __webpack_public_path__ + "static/media/bag-game-entry-group.a8ccb98d.png";